import 'babel-polyfill'
import Vue from 'vue'
import Router from 'vue-router'
import Main from '@/components/Main'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(ElementUI)
Vue.use(Router)

export default new Router({
  base: '/hyOfficial/',
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Main',
      component: Main
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js